import axios from 'axios'
import Store from '@/store/index'
import { Message, Loading } from 'element-ui'

const options = {
  lock: true,
  text: '请稍等',
  spinner: 'el-icon-loading',
  background: 'rgba(0, 0, 0, 0.5)'
}
const axiosInstance = axios.create()
// api请求域名
const baseHost = process.env.VUE_APP_API_HOST

// 默认值
axiosInstance.defaults.timeout = 300000
axiosInstance.defaults.baseURL = baseHost
// withCredentials为true：request header会带上cookie信息
axiosInstance.defaults.withCredentials = true
axiosInstance.defaults.responseType = 'json'
axiosInstance.defaults.headers.common['Cache-Control'] = 'no-cache'
axiosInstance.defaults.headers.get['If-Modified-Since'] = '0'
axiosInstance.defaults.cache = false

// 请求拦截器
axiosInstance.interceptors.request.use(
  (config) => {
    // 每次发送请求前，判断vuex中是否存在token，如果存在，则在header头上带上token信息
    const token = Store.state.user.userToken
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error.response)
  }
)

// // 响应拦截器
axiosInstance.interceptors.response.use(
  (response) => {
    if (response.data.code === 'authorization.signin.failed' ||
      response.data.code === 'authentication.failed' ||
      response.data.message === 'auth failure, please sign in.') {
      const query = window.location.href?.split('?')
      const queryStr = query && query.length > 1 ? `?${query[1]}` : ''
      const teamSpaceHref = window.location.origin.includes('www-local') ? '/' : '/teamspace'
      // 正常跳转到登录页
      window.location.href = `${window.location.origin}${teamSpaceHref}#/signin${queryStr}`
    }

    // 对共享中的资源被删除的情况做处理
    if (response.data.code === 'space.permission.denied') {
      Message.error('您没有该空间的访问权限，无法继续操作')
      const query = window.location.href?.split('?')
      const queryStr = query && query.length > 1 ? `?${query[1]}` : ''
      const teamSpaceHref = window.location.origin.includes('www-local') ? '/' : '/teamspace'
      const isInOpenFilePage = sessionStorage.getItem('inOpenFilePage')
      // 正常跳转到首页或者打开云盘文件的首页
      window.location.href = isInOpenFilePage === 'Y'
        ? `${window.location.origin}${teamSpaceHref}#/open/spaceList${queryStr}`
        : `${window.location.origin}${teamSpaceHref}#/${queryStr}`
    }

    if (response.data.code !== 200 && response.data.code !== 'success') {
      // 对接口中共同的特定code做处理
      const messageTips = {
        'resource.not.exist': '资源不存在',
        'custom.category.not.found': '资源不存在',
        'file.revision.not.exist': '文件修订版本不存在',
        'file.not.exist': '文件不存在',
        'permission.denied': '暂无权限，请刷新后重试',
        'system.error': '系统错误',
      }
      const resCode = response.data.code
      const message = messageTips[resCode]
      if (message) {
        Message.error(message)
        // 中断，防止弹出多个错误信息
        throw Error('message')
      }
      return Promise.reject(response.data)
    } else {
      if (response.headers['x-pagination-total-count']) {
        response.data.total = response.headers['x-pagination-total-count']
      }
      return response.data.data
    }
  },
  (error) => { return Promise.reject(error.response) }
)

// 发送请求
const send = (config, loading) => {
  const configs = Object.assign({
    headers: {},
    timeout: 300000
  }, config)
  let loadingInstance
  if (loading) {
    const loadingOption = typeof loading === 'object' ? { ...options, ...loading } : options
    loadingInstance = Loading.service(loadingOption)
  }
  return axiosInstance(configs).then((res) => {
    if (loading) {
      loadingInstance && loadingInstance.close()
    }
    return res
  }).catch((error) => {
    if (error) {
      const isThreeApi = !!error.config && new RegExp(/.*\/gcmp_server\/display_data$/).test(error.config.url)
      if (!isThreeApi && error.status >= 500) {
        Message.error('服务器异常')
      }
    }
    loadingInstance && loadingInstance.close()
    return Promise.reject(error)
  })
}

const post = (url, params = {}, headers = {}, loading, configObj = {}) => {
  let config = {
    method: 'post',
    url,
    data: params,
    headers: headers,
    ...configObj
  }
  if (typeof params === 'string') {
    headers['Content-Type'] = 'text/plain'
    config = {
      ...config
    }
  }
  return send(config, loading)
}
const patch = (url, params = {}, loading) => {
  const config = {
    method: 'patch',
    url,
    data: params
  }
  return send(config, loading)
}
const put = (url, params = {}, loading) => {
  const config = {
    method: 'put',
    url,
    data: params
  }
  return send(config, loading)
}
const get = (url, params = {}, headers = {}, loading) => {
  let urlParams = []
  Object.keys(params).forEach((key) => {
    // 如果值为空，则不传该属性
    if (params[key] || params[key] === 0 || params[key] === false) {
      urlParams.push(`${key}=${encodeURIComponent(params[key])}`)
    }
  })
  if (urlParams.length) {
    urlParams = `${url}?${urlParams.join('&')}`
  } else {
    urlParams = url
  }
  const config = {
    url: urlParams,
    headers: headers,
    params: {
      randomTime: new Date().getTime() // 防止缓存
    }
  }
  return send(config, loading)
}

const axDelete = (url, headers = {}, loading, data) => {
  const config = {
    method: 'delete',
    url,
    headers: headers,
    data
  }
  return send(config, loading)
}

export default {
  post,
  patch,
  put,
  get,
  axDelete
}
